<template>
  <v-dialog :value="isActive" @click:outside="$emit('added:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span> {{ method === "post" ? "Add" : "Edit" }} Company</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <custom-form
        :fields="company"
        :method="method"
        :action="url"
        @submitted="$emit('added', $event)"
      >
        <v-container>
          <v-row no-gutters>
            <v-col cols="12"> <custom-input name="registered_id" label="Registration Id" /></v-col>
            <v-col cols="12"> <custom-input name="name" label="Name" /></v-col>
            <v-col cols="12">
              <custom-user-search
                name="target_user_id"
                label="Select the owner"
                item_name="full_name"
                item_value="id"
                icon="mdi-account-search"
              />
            </v-col>
            <v-col cols="12"> <custom-input name="country_code" label="Country Code" /></v-col>
            <v-col cols="12">
              <custom-select
                name="is_sole_proprietorship"
                label="Is Sole Proprietorship?"
                :items="[true, false]"
              />
            </v-col>
            <v-col cols="12">
              <custom-select
                name="activity_id"
                class="form-group"
                label="Activity"
                :items="activitiesOptions"
              />
            </v-col>
            <v-col cols="12">
              <custom-select
                name="revenue_level_id"
                class="form-group"
                label="Revenue Levels"
                :items="revenueLevelOptions"
              />
            </v-col>
            <v-col cols="10"
              ><custom-select
                name="receiving_countries_ids"
                :items="transferCountries"
                item-text="name"
                item-value="id"
                label="Transfer Receiving Countries"
                multiple
              />
            </v-col>
            <v-col cols="6"> <custom-input name="address" label="Address" /></v-col>
            <v-col cols="6" class="pl-1">
              <custom-input name="street_number" label="Street Number"
            /></v-col>
            <v-col cols="6">
              <custom-input name="complement_address" label="Complement Address"
            /></v-col>

            <v-col cols="6" class="pl-1">
              <custom-input name="postal_code" label="Postal Address"
            /></v-col>
            <v-col cols="12">
              <custom-input name="city" label="City" />
            </v-col>
            <v-col cols="12">
              <custom-input name="quarter" label="Quarter" />
            </v-col>
            <!-- <custom-select
            :items="countries"
            name="birth_country"
            item-text="name"
            item-value="name"
            label="Country of Birth"
          /> -->
            <!-- <custom-textarea name="reason_for_modification" label="Update Reason" /> -->
            <v-col cols="12">
              <custom-button block color="primary">
                <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                <v-icon v-else>mdi-pencil</v-icon>
                {{ method === "post" ? "Add" : "Edit" }}
              </custom-button>
            </v-col>
          </v-row>
        </v-container>
      </custom-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    company: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      countries: [],
      transferCountries: [],
      activities: [],
      revenue_levels: [],
    };
  },
  computed: {
    activitiesOptions() {
      return this.getSelectOptions(this.activities);
    },
    revenueLevelOptions() {
      return this.getSelectOptions(this.revenue_levels);
    },
    url() {
      return this.method === "post"
        ? `/api/v1/companies/registerFromBackOffice`
        : `/api/v1/companies/${this.company.id}`;
    },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
  },
  async created() {
    await this.$http.get("/api/v1/get-countries").then((response) => (this.countries = response));
    await this.$http
      .get("/api/v1/individual-activities")
      .then((response) => (this.activities = response.data));
    await this.$http
      .get("/api/v1/revenue-levels")
      .then((response) => (this.revenue_levels = response.data));
    await this.$http
      .get("/api/v1/transactions/transferCountries")
      .then(({ data }) => (this.transferCountries = data));
  },
};
</script>
